import { Control, Controller } from "react-hook-form";

import { RelevanceScoreButtons } from "../../form_components/RelevanceScoreButtons";
import { FrameworkFilters } from "../utils";

import css from "./SignalScore.module.scss";

export interface SignalScoreFilterContentProps {
  control: Control<FrameworkFilters, unknown>;
}

function SignalScoreFilterContent({ control }: SignalScoreFilterContentProps) {
  return (
    <div className={css.filterSection} aria-label="Signals filters">
      <Controller
        name="signalScore"
        control={control}
        render={({ field }) => (
          <div className={css.inputContainer}>
            <RelevanceScoreButtons {...field} entityType="framework" />
          </div>
        )}
      />
    </div>
  );
}

export default SignalScoreFilterContent;
